import { useDispatch } from 'react-redux';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';
import UnFinalizeButton from '../moreActions/UnFinalizeButton';
import GenerateClaimFormButton from '../GenerateClaimFormButton';
import FinalizeButton from '../moreActions/FinalizeButton';
import { ExportButton } from '../../../../itrust_common/components/others';
import DuplicateOrderButton from '../../buttons/DuplicateOrderButton';
import DeleteOrderButton from '../../buttons/DeleteOrderButton';
import { orderInvoiceEmail, orderInvoicePrint } from '../../../../redux/actions/order/orderActions';
import CurrencyIconsView from '../../../../itrust_common/components/others/CurrencyIconsView';
import EditExamButton from '../../buttons/EditExamButton';
import PaymentsButton from '../../order/moreActions/PaymentsButton';
import RefundsButton from '../../order/moreActions/RefundsButton';

var timeout = null;
export default function OrderHeader(props) {
  const { order, onRemoteSubmit, accordionToggle, setAccordionToggle, handleOrderEditCancel, activeTab, handleTabChange, claimFormData } = props;
  const dispatch = useDispatch();

  const getBalanceDueBgColor = () => {
    if (order.balance_due > 0) {
      return 'bg-danger'
    }
    else if (order.balance_due < 0) {
      return 'bg-success'
    }
    else {
      return 'bg-dark'
    }
  }

  const getTotalPaidBgColor = () => {
    if (order.amount_paid > 0) {
      return 'bg-success'
    }
    else {
      return 'bg-dark'
    }
  }

  const handleOnSave = () => {
    switch (activeTab) {
      case 1: onRemoteSubmit('orderProcedureForm'); break
      case 2: onRemoteSubmit('orderContactLensForm'); break
      case 3: onRemoteSubmit('orderEyeglassForm'); break
      case 4: onRemoteSubmit('orderMiscItemForm'); break
      default:
    }
  }

  const handleEmailInvoice = () => {
    dispatch(orderInvoiceEmail(order.id))
  }

  const handlePrintInvoice = async () => {
    let res = await dispatch(orderInvoicePrint(order.id))
    window.open(res.value.data.filepath, '_blank')
  }

  return (
    <div className="d-flex flex-row justify-content-between align-items-center text-nowrap">
      <div className="d-flex align-items-start">
        <div>
          <h5 className="mr-2">Patient Order Form</h5>
          <span className="ml-1"><strong>ID:</strong> {order.id}</span>
        </div>
        <a className="collapsed border border-primary rounded-circle ml-2" onClick={() => setAccordionToggle(!accordionToggle)} role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          <i className="la la-sm la-angle-down text-primary px-2 pt-2" />
        </a>
        <div className='mx-8 align-self-center'>
          <span className={`rounded text-white mr-5 py-3 px-5 ${getBalanceDueBgColor()}`}>Balance Due: <CurrencyTypeView amount={order.balance_due} /></span>
          <span className={`rounded text-white py-3 px-5 ${getTotalPaidBgColor()}`}>Total Paid: <CurrencyTypeView amount={order.amount_paid} /></span>
        </div>
      </div>
      <div className='d-flex align-items-center'>
        {order.status == 'finalized' && order.patient_insurance_id && (order.claim_amount > 0.0 || order.insurance_receivable <= 0.0) && !claimFormData.id && <GenerateClaimFormButton order={order} dispatch={dispatch} handleTabChange={handleTabChange} />}
        {order.exam_examination_id &&
          <EditExamButton storeId={order.store_id} examId={order.exam_examination_id}>
            <button type="button" className="btn btn-outline-primary mx-lg-3">Open Exam</button>
          </EditExamButton>
        }
        <button className="btn btn-outline-primary mx-lg-3" onClick={handleOnSave}>Save Order</button>
        {order.status === "finalized" &&
          <UnFinalizeButton appointmentId={order.appointment_id} orderId={order.id}>
            <button
              type="button"
              className="btn btn-warning mx-lg-3">
              Unfinalize and Edit
            </button>
          </UnFinalizeButton>
        }
        {order.status === "finalized" &&
          <button
            type="button"
            className="btn btn-success mx-lg-3">
            Finalized
          </button>
        }
        {(order.balance_due || order.status !== "finalized") ?
          <FinalizeButton showRequiredAuth={order.patient_insurance_attributes?.is_prior_authorization_required && !order.prior_authorization_number} orderStaffId={order.staff_attributes?.id} balanceDue={order.balance_due} onFinalize={handleOnSave} orderId={order.id} patientName={order.patient_attributes?.name}>
            <button
              type="button"
              className="btn btn-primary mx-lg-3">
              {order.balance_due ? 'Pay' : 'Finalize Order'}
            </button>
          </FinalizeButton> : ''
        }
        <div className="dropdown d-inline-block mx-3 bg-light">
          <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            More Actions
            <i className="ml-3 la la-angle-down la-sm" />
          </button>
          <div className="dropdown-menu border-0 shadow rounded my-3" aria-labelledby="dropdownMenuButton">
            <RefundsButton orderId={order.id}>
              <a className="dropdown-item d-flex align-item-center border-bottom border-bottom-2 border-light py-3" href="#">
                <i className="la la-sm mr-3 la-history" />
                Refund
              </a>
            </RefundsButton>
            <PaymentsButton orderId={order.id}>
              <a className="dropdown-item d-flex align-item-center border-bottom border-bottom-2 border-light py-3" href="#">
                <CurrencyIconsView className="mr-3" />
                Payment Details
              </a>
            </PaymentsButton>
            <a className="dropdown-item d-flex align-item-center border-bottom border-bottom-2 border-light py-3" onClick={handleEmailInvoice}>
              <i className="la la-sm mr-3 la-paper-plane" />
              Email Invoice
            </a>
            <a className="dropdown-item d-flex align-item-center border-bottom border-bottom-2 border-light py-3 pointer" onClick={handlePrintInvoice}>
              <i className="la la-sm mr-3 la-print" />
              Print Invoice
            </a>
            <ExportButton
              path={`/v1/orders/${order.id}/download_invoice_pdf`}
              label={<span><i className="la la-sm mr-3 la-edit" />Download Invoice</span>}
              className="dropdown-item d-flex align-item-center border-bottom border-bottom-2 border-light rounded-0"
            />
            <DuplicateOrderButton orderId={order.id} >
              <a className="dropdown-item d-flex align-items-center py-3"><i className="la la-copy la-sm mr-3" />Duplicate</a>
            </DuplicateOrderButton>
            <DeleteOrderButton order={order} onDeleteHook={handleOrderEditCancel}>
              <a className="dropdown-item d-flex align-items-center text-danger py-3"><i className="la la-trash la-sm mr-3" />Delete</a>
            </DeleteOrderButton>
          </div>
        </div>
        <button className="btn btn-outline-primary mx-3" data-dismiss="modal">Close</button>
      </div>
    </div>
  )
}